// Can't get out of useBreakpointValue here :P
// eslint-disable-next-line no-restricted-syntax
import { DEFAULT_BREAKPOINT, useBreakpointValue } from '@hub/design-system-base'

const useMobileBreakpoint = (): boolean =>
  useBreakpointValue([true, true, false], DEFAULT_BREAKPOINT) ?? false

export default useMobileBreakpoint
